export default "__VITE_ASSET__becde219__"